require('./brokerHireInvestmentFundsView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @ actions
const investmentFundsActions = require('actions/investmentFunds');
const brokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');
const { sendBrokerPreContractualMailV2, resetPrecontractualMail } = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');
const PrinterActions = require('actions/contactCenter/printer');
const brokerFundLegalDocument = require('actions/brokerFundLegalDocument');
import {
    removeLegalDocumentation,
} from 'actions/brokerLegalDocumentation';
const BlockedAccountsAction = require('actions/blockedAccounts');
const brokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');
const blockedAccounts = require('actions/blockedAccounts');


// @ commons
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ components
const BrokerHireInvestmentFundHeader = require('components/broker/brokerHireInvestment/brokerHireInvestmentFundHeader/brokerHireInvestmentFundHeader');
const BrokerHireInvestmentFund = require('components/broker/brokerHireInvestment/brokerHireInvestmentFund/brokerHireInvestmentFund');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const MorningStarCopyright = require('components/commons/morningStarCopyright/morningStarCopyright');
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');

// @ helpers
const { buildLinks } = require('utilities/fundsHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled')
const { PROC_BROKER_FUNDS_PG_NAME } = require('utilities/tagging.js')

// @constants
const {
    FIRST_STEP,
    BROKER_RED_FUND,
    BROKER_YELLOW_FUND,
    BROKER_GREEN_FUND,
    BROKER_MIFID_FUND_RED,
    BROKER_MIFID_FUND_YELLOW,
    BROKER_MIFID_FUND_GREEN,
    BROKER_FUND_MIFID_ID,
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_EXPLORE_FUNDS_URL,
    BROKER_DOCUMENT_TYPE,
    BROKER_ORDER_TYPE_BUY,
    BROKER_CONVENIENCE_MIFID_FUND,
    BROKER_CONVENIENCE_MIFID_FUND_BUY,
    BROKER_CONVENIENCE_MIFID_FUND_SUSCRIBE,
    BROKER_MIFID_VERSION_2,
} = require('constants/index');
const NextButtonWrapper = require("components/contactCenter/nextButtonWrapper/nextButtonWrapper");
const { FundLegalConfirmation } = require('components/contactCenter/brokerLegalConfirmation/fundLegalConfirmation/fundLegalConfirmation');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const {
    PRODUCT_TYPE,
    BUY_ORDER_TYPE,
} = require('constants/contactCenter/brokerFundsSendEmailConstants');
const { HIRE_FUNDS } = require('constants/operationCodesAccounts');
const { WEALTH_SEPBLAC_BLOCKED_ACCOUNTS } = require('constants/flagBasedFeatures');


class BrokerHireInvestmentFundsView extends React.Component {
    constructor(props) {
        super(props);

        this.checkMifid = true;

        this.state = {
            displayWizard: !__CONTACT_CENTER__,
            selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY,
            stepNumber: ''
        };

        this.handleFinish = this.handleFinish.bind(this);
        this.onAccountNumberChange = this.onAccountNumberChange.bind(this);
        this.onSetAmountChange = this.onSetAmountChange.bind(this);
        this.handleShowWizard = this.handleShowWizard.bind(this);
        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);
        this.onChangeContract = this.onChangeContract.bind(this);
        this.requestIntervenersContractByContractNumber = this.requestIntervenersContractByContractNumber.bind(this);
        this.setIsSubscription = this.setIsSubscription.bind(this);
        this.setIsNewContract = this.setIsNewContract.bind(this);
        this.validateSchema = this.validateSchema.bind(this);
        this.onStepChange = this.onStepChange.bind(this)
    }

    componentDidMount() {
        const { onStartOperation, match: { params: { fundId, contractId } }, getBlockedAccounts, immAccounts, getBlockedAccountBySepblac, immFlagBasedFeatures, history } = this.props;
        if (immFlagBasedFeatures.get(WEALTH_SEPBLAC_BLOCKED_ACCOUNTS)) {
            getBlockedAccountBySepblac(history);
        }
        onStartOperation(fundId, contractId);
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_FUNDS);
    }

    componentWillUnmount() {
        const {
            clearSearchResults,
            reset,
            resetPrintedIndicators,
            removeLegalDocumentation
        } = this.props
        reset();
        resetPrintedIndicators();
        removeLegalDocumentation();
        clearSearchResults();
    }

    onStepChange(stepNumber) {
        this.setState({ stepNumber });
    }

    handleLegalYesNoOptionChange(value) {
        this.setState({
            selectedLegalConfirmationValue: value
        });
    }

    handleShowWizard() {
        this.setState({
            displayWizard: true,
        });
    }

    onAccountNumberChange(accountNumber, accountAmount) {
        this.props.onChangeSelectedAccount(accountNumber, accountAmount);
    }

    setIsSubscription(fundId) {
        this.props.changeToSubscription(fundId);
    }

    validateSchema(isValid) {
        this.props.validateSchema(isValid)
    }

    setIsNewContract() {
        this.props.changeToNewContract();
    }

    onChangeContract(contractToChange) {
        this.props.onChangeContract(contractToChange)
    }
    requestIntervenersContractByContractNumber(contractNumber) {
        this.props.getIntervenersContractByContractNumber(contractNumber);
    }

    onSetAmountChange(value) {
        this.props.setAmount(value);
    }

    getFundMifidId() {
        const fundType = this.props.immInvestmentFunds.getIn([
            'steps',
            FIRST_STEP,
            'investmentFunds',
            'customCategoryId3'
        ]);

        switch (fundType) {
            case BROKER_RED_FUND:
                return BROKER_MIFID_FUND_RED;
            case BROKER_YELLOW_FUND:
                return BROKER_MIFID_FUND_YELLOW;
            case BROKER_GREEN_FUND:
                return BROKER_MIFID_FUND_GREEN;
            default:
                return BROKER_FUND_MIFID_ID;
        }
    }

    buildHeader() {
        const { immInvestmentFunds } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        const titleKey = isSubscription
            ? 'additionalSubscriptionInvestmentFunds'
            : 'hireInvestmentFunds';
        const titleBreadcrumb = isSubscription
            ? 'additionalSubscriptionInvestmentFundsBreadcrumb'
            : 'hireInvestmentFunds';

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('breadcrumb-brokerAdvancedSearch'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: formatText(`breadcrumb-${titleBreadcrumb}`),
                url: MYPROFILE_BROKER_URL
            }
        ];

        return (
            <OKCover size="medium" section="broker" customClass="col-xs-12">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    finalTitle={getFinalTitle(formatText(`breadcrumb-${titleKey}`))} >
                    <OKButton
                        onClick={() => {
                            taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, 'GoToSearchButton', this.state.stepNumber)
                        }}
                        inverse={true}
                        modifier="ghost"
                        to={MYPROFILE_BROKER_EXPLORE_FUNDS_URL}
                    >
                        <FormattedText value="broker-goToAdvancedSearch" />
                    </OKButton>
                </OKHeaderSubPage>
            </OKCover>
        );
    }

    handleCancel() {
        const url = MYPROFILE_BROKER_URL;
        this.props.history.push(url);
    }

    handleFinish() {
        const { immInvestmentFunds, history } = this.props;
        const isSubscription = immInvestmentFunds.getIn(['steps', 0, 'isSubscription']);
        if (isSubscription) {
            this.props.addSubscription(history);
        } else {
            this.props.hireInvestment(history);
        }
    }

    isAbleToContinue() {
        return (this.state.selectedLegalConfirmationValue === SELECTED_VALUES.YES);
    }

    buildNextButtonWrapperLegalConfirmation() {
        const {
            immProfileFields,
            immPreContractualMail,
            immInvestmentFunds,
            resetPrecontractualMail,
            requestProfile,
            sendBrokerPreContractualMailV2,
            immFlagBasedFeatures,
            match: { params: { fundId } }
        } = this.props;

        const fundIsin = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']);
        const fundSecId = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'secId']);
        const fundName = trim(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']));
        const clientEmailAddress = PersonalDataHelper.getEmail(immProfileFields);
        const nombreCliente = immProfileFields.get('nombreCliente', '');
        const isEnableExAnteCost = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");

        const sendMailParams = {
            clientAlias: nombreCliente,
            email: clientEmailAddress,
            isin: fundIsin,
            isinDescribe: fundName,
            productType: PRODUCT_TYPE,
            orderType: BUY_ORDER_TYPE,
        };

        return (
            <NextButtonWrapper
                buttonContainerClassName="hire-investment-funds__next-button"
                canContinue={this.isAbleToContinue()}
                onContinue={this.handleShowWizard}
            >
                <FundLegalConfirmation
                    className="content-box"
                    fundIsin={fundIsin}
                    fundSecId={fundSecId}
                    fundName={fundName}
                    immProfileFields={immProfileFields}
                    immPreContractualMail={immPreContractualMail}
                    sendMail={sendBrokerPreContractualMailV2}
                    sendMailParams={sendMailParams}
                    resetMailState={resetPrecontractualMail}
                    requestProfile={requestProfile}
                    selectedYesNoOption={this.state.selectedLegalConfirmationValue}
                    onYesNoOptionChange={this.handleLegalYesNoOptionChange}
                    costDocumentType={BROKER_DOCUMENT_TYPE}
                    costOrderType={BROKER_ORDER_TYPE_BUY}
                    fundId={fundId}
                    withoutCostDocument={isEnableExAnteCost}
                />
            </NextButtonWrapper>
        );
    }

    render() {
        const {
            immInvestmentFunds,
            immStocksContractForm,
            immAccounts,
            setVisibleStep,
            validateStep,
            setWillCancel,
            immBrokerMyInvestments,
            immBrokerProductAdvancedSearch,
            immFlagBasedFeatures,
            getBuyFundsDataExtantCosts,
            match: { params: { fundId, contractId } }
        } = this.props;
        const header = this.buildHeader();
        const accountsMap = immAccounts.get('byId');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');
        const immBlockedAccountsIds = immAccounts.get('blockedAccountsIds');
        const accountNumber = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'accountNumber']);
        const notFound = immInvestmentFunds.get('notFound');
        const isSubscription = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'isSubscription']);
        const wizzardTitle = isSubscription
            ? 'additionalSubscriptionInvestmentFunds'
            : 'hireInvestmentFunds';

        if (immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds']) && immBrokerProductAdvancedSearch.get('fetched')) {
            const fundType = this.props.immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'customCategoryId3']);
            const productName = trim(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'name']));
            const productUrl = buildLinks(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin']));
            const appendContract = contractId ? `/${contractId}` : '';
            const continuationUrl = `/myprofile/broker/buyInvestmentFunds/${fundId}${appendContract}`;
            const productType = contractId ? BROKER_CONVENIENCE_MIFID_FUND_SUSCRIBE : BROKER_CONVENIENCE_MIFID_FUND;
            const mifidOptions = {
                hideAlreadyPerformTestResult: fundType === BROKER_YELLOW_FUND || fundType === BROKER_GREEN_FUND,
                productType,
                operationType: BROKER_CONVENIENCE_MIFID_FUND_BUY,
            };
            const legalConfirmation = __CONTACT_CENTER__ && !this.state.displayWizard ? this.buildNextButtonWrapperLegalConfirmation() : null;

            if (immAccounts.get('isFetchingBlockedAccountBySepblac')) {
                return <LoadingSection />;
            }

            return (
                <BrokerMiFIDBehavior
                    mifidVersion={BROKER_MIFID_VERSION_2}
                    productName={productName}
                    productUrl={productUrl}
                    continuationUrl={continuationUrl}
                    productIsinId={immInvestmentFunds.getIn(['steps', FIRST_STEP, 'investmentFunds', 'isin'])}
                    productMifidId={this.getFundMifidId()}
                    mifidOptions={mifidOptions}
                >
                    <div>
                        <div className="container-fluid card-details--header-identifier">
                            <div className="row">
                                {header}
                            </div>
                        </div>
                        <div className="grid-view__body">
                            <div className="container-fluid">
                                <div className="row grid-view--content-position-negative">
                                    <div className="col-xs-12">
                                        <BrokerHireInvestmentFundHeader
                                            immBrokerProductAdvancedSearch={immBrokerProductAdvancedSearch}
                                            immInvestmentFunds={immInvestmentFunds}
                                            modifier="etfs"
                                        />
                                        {legalConfirmation}
                                        {this.state.displayWizard && <BrokerHireInvestmentFund
                                            validateStep={validateStep}
                                            setVisibleStep={setVisibleStep}
                                            immInvestmentFunds={immInvestmentFunds}
                                            setWillCancel={setWillCancel}
                                            onCancel={() => this.handleCancel()}
                                            onFinish={this.handleFinish}
                                            wizzardTitle={wizzardTitle}
                                            immAccounts={accountsMap}
                                            immBlockedAccountsIds={immBlockedAccountsIds}
                                            immStocksContractForm={immStocksContractForm}
                                            immBrokerMyInvestments={immBrokerMyInvestments}
                                            immFlagBasedFeatures={immFlagBasedFeatures}
                                            handleAccountChange={this.onAccountNumberChange}
                                            handleSetAmount={this.onSetAmountChange}
                                            accountSelected={accountNumber}
                                            setIntervenerName={this.props.setIntervenerName}
                                            setIntervenerType={this.props.setIntervenerType}
                                            addIntervener={this.props.addIntervener}
                                            removeIntervener={this.props.removeIntervener}
                                            restoreDefaultInterveners={this.props.restoreDefaultInterveners}
                                            isBlockedAccountsLoading={isBlockedAccountsLoading}
                                            handleChangeContract={this.onChangeContract}
                                            setIsSubscription={this.setIsSubscription}
                                            setIsNewContract={this.setIsNewContract}
                                            validateSchema={this.validateSchema}
                                            getIntervenersContractByContractNumber={this.requestIntervenersContractByContractNumber}
                                            fundId={fundId}
                                            extantDataFetch={getBuyFundsDataExtantCosts}
                                            onStepChange={this.onStepChange}
                                        />}
                                    </div>
                                </div>
                                <div>
                                    <MorningStarCopyright fromFunds={true} />
                                </div>
                            </div>
                        </div>
                    </div>
                </BrokerMiFIDBehavior>
            );
        } else if (notFound) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            {header}
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-positive">
                                <div className="col-xs-12">
                                    <EmptyState primaryText={'No se han encontrado datos del fondo'} iconType="noitems-banking" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return <LoadingSection />;
        }
    }
}

BrokerHireInvestmentFundsView.propTypes = {
    onStartOperation: PropTypes.func.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    getSubscriptionDetails: PropTypes.func.isRequired,
    setIsSubscription: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setAmount: PropTypes.func,
    immAccounts: PropTypes.object.isRequired,
    immStocksContractForm: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object,
    getMorningStarScreener: PropTypes.func,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    hireInvestment: PropTypes.func.isRequired,
    addSubscription: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immReimburseInvestment: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    sendBrokerPreContractualMailV2: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    onChangeSelectedAccount: PropTypes.func.isRequired,
    onChangeContract: PropTypes.func.isRequired,
    getIntervenersContractByContractNumber: PropTypes.func.isRequired,
    removeLegalDocumentation: PropTypes.func.isRequired,
    changeToNewContract: PropTypes.func.isRequired,
    changeToSubscription: PropTypes.func.isRequired,
    validateSchema: PropTypes.func.isRequired,
    clearSearchResults: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    getBuyFundsDataExtantCosts: PropTypes.func,
    getBlockedAccountBySepblac: PropTypes.func,
};

module.exports.constructor = BrokerHireInvestmentFundsView;
module.exports.BrokerHireInvestmentFundsView = connect(
    state => ({
        immInvestmentFunds: state.investmentFunds,
        immAccounts: state.accounts,
        immProfileFields: state.profile,
        immPreContractualMail: state.preContractualMail,
        immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
        immBrokerFundLegalDocument: state.brokerFundLegalDocument,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immReimburseInvestment: state.reimburseInvestment,
        immStocksContractForm: state.brokerStocksContractForm,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }), {
    getBuyFundsDataExtantCosts: investmentFundsActions.postExtantCostsBuyFunds,
    onStartOperation: investmentFundsActions.operationStarted,
    resetPrintedIndicators: PrinterActions.resetPrintedIndicators,
    getSubscriptionDetails: investmentFundsActions.getSubscriptionDetails,
    getBlockedAccounts: BlockedAccountsAction.getBlockedAccounts,
    resetBlockedAccounts: BlockedAccountsAction.resetBlockedAccounts,
    validateStep: investmentFundsActions.validateStep,
    setIsSubscription: investmentFundsActions.setIsSubscription,
    setVisibleStep: investmentFundsActions.setVisibleStep,
    setWillCancel: investmentFundsActions.setWillCancel,
    reset: investmentFundsActions.reset,
    getMorningStarScreener: investmentFundsActions.getMorningStarScreener,
    setAmount: investmentFundsActions.setAmount,
    setWillLeave: investmentFundsActions.setWillLeave,
    setIntervenerName: investmentFundsActions.setIntervenerName,
    setIntervenerType: investmentFundsActions.setIntervenerType,
    addIntervener: investmentFundsActions.addIntervener,
    removeIntervener: investmentFundsActions.removeIntervener,
    restoreDefaultInterveners: investmentFundsActions.restoreDefaultInterveners,
    hireInvestment: investmentFundsActions.hireInvestment,
    addSubscription: investmentFundsActions.addSubscription,
    onStartConvenienceMiFIDTest: brokerConvenienceMiFIDTestAction.start,
    sendBrokerPreContractualMailV2: sendBrokerPreContractualMailV2,
    resetPrecontractualMail: resetPrecontractualMail,
    requestProfile: profileActions.requestProfile,
    fetchLegalDocuments: brokerFundLegalDocument.fetchLegalDocuments,
    onChangeSelectedAccount: investmentFundsActions.changeSelectedAccount,
    removeLegalDocumentation: removeLegalDocumentation,
    onChangeContract: investmentFundsActions.changeContract,
    getIntervenersContractByContractNumber: investmentFundsActions.getIntervenersContractByContractNumber,
    changeToNewContract: investmentFundsActions.changeToNewContract,
    changeToSubscription: investmentFundsActions.changeToSubscription,
    clearSearchResults: brokerProductAdvancedSearchActions.clearResults,
    validateSchema: investmentFundsActions.validateSchema,
    getBlockedAccountBySepblac: blockedAccounts.getBlockedAccountBySepblac
}
)(withRouter(BrokerHireInvestmentFundsView));
